import { useCallback, useEffect, useRef, useState } from 'react'
import { useWeb3Connection } from '../Web3Provider'

const ENS_DOMAINS_KEY = 'ENS_DOMAINS'

type Domain = {
    name: string
    timestamp: number
}

type EnsDomainStorage = Record<string, Domain>

const getSavedEnsDomains = () => {
    const ensNames = localStorage.getItem(ENS_DOMAINS_KEY)
    return ensNames ? JSON.parse(ensNames) : {}
}

const storeEnsDomains = (mapping: EnsDomainStorage) => {
    localStorage.setItem(ENS_DOMAINS_KEY, JSON.stringify(mapping))
}

export const useEnsDomain = () => {
    const savedDomains = useRef<EnsDomainStorage>(getSavedEnsDomains())
    const { account, provider } = useWeb3Connection()
    const [ensDomain, setEnsDomain] = useState<string>('')
    const storeEnsDomain = useCallback((name: string) => {
        storeEnsDomains(savedDomains.current)
        setEnsDomain(name)
    }, [])

    const findEnsName = useCallback(
        async (account: string) => {
            let name = ''
            try {
                name = (await provider?.lookupAddress(account)) || ''
                // eslint-disable-next-line no-empty
            } catch (e) {}

            savedDomains.current[account] = {
                name,
                timestamp: new Date().getTime(),
            }

            storeEnsDomain(name)
        },
        [provider, storeEnsDomain]
    )

    useEffect(() => {
        if (!account) return
        const accountDomain = savedDomains.current[account] ?? null

        if (accountDomain) {
            setEnsDomain(accountDomain.name)
        } else {
            findEnsName(account)
        }
    }, [account, findEnsName])

    return ensDomain
}
